<template>
  <div>
    <div class="actions nowrap">
      <!-- showChip -->
      <div v-if="item.showChip">
        <v-chip
          :color="item.chipColor"
          small
          outlined
          class="mr-2"
          @click="editItem(item)"
        >
          {{ item.load_status }}
        </v-chip>
      </div>
      <!-- canSetRead -->
      <div v-if="item.canSetRead">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="SetReadItem(item)"
            >
              mdi-email-check-outline
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Žymėti kaip perskaitytą') }}</div>
        </v-tooltip>
      </div>
      <!-- canReload -->
      <div v-if="item.canReload">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="reloadItem(item)"
            >
              mdi-archive-refresh-outline
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Atnaujinti') }}</div>
        </v-tooltip>
      </div>
      <!-- canEdit -->
      <div v-if="item.canEdit">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="editItem(item)"
            >
              mdi-pencil-outline
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Redaguoti') }}</div>
        </v-tooltip>
      </div>
      <!-- canEdit -->
      <div v-if="item.canFixPerson">
        <v-btn
          dense
          small
          class="mx-1 primary"
          @click="fixPerson(item)"
        >
          TIKRINTI ASMENĮ ASMENYSE
        </v-btn>
      </div>
      <!-- canAddToCart -->
      <div v-if="item.canAddToCart">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="addToCartItem(item)"
            >
              mdi-credit-card-outline
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Apmokėti') }}</div>
        </v-tooltip>
      </div>
      <!-- goToCart -->
      <div v-if="item.canPay">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="goToCartItem(item)"
            >
              mdi-credit-card-outline
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Apmokėti') }}</div>
        </v-tooltip>
      </div>
      <!-- canIregEdit -->
      <div v-if="item.canIregEdit">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="iregEditItem(item)"
            >
              mdi-hammer
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Tvarkyti') }}</div>
        </v-tooltip>
      </div>
      <!-- canIregView -->
      <div v-if="item.canIregView">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="iregViewItem(item)"
            >
              mdi-eye-check
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Peržiūrėti') }}</div>
        </v-tooltip>
      </div>
      <!-- can view -->
      <div v-if="item.canEditSignatures">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="viewItem(item)"
            >
              mdi-account-check-outline
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Peržiūrėti') }}</div>
        </v-tooltip>
      </div>

      <div v-if="item.canApproveSignatures">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="approveSignatures(item)"
            >
              mdi-hammer
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Tvarkyti') }}</div>
        </v-tooltip>
      </div>

      <div v-if="item.canViewApprovedSignatures">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="viewSignatures(item)"
            >
              mdi-eye-check
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Peržiurėti') }}</div>
        </v-tooltip>
      </div>

      <!-- canView -->
      <div v-if="item.canView">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="viewItem(item)"
            >
              mdi-eye-check
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Peržiūrėti') }}</div>
        </v-tooltip>
      </div>
       <!-- canView -->
      <div v-if="item.canViewHistory">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="historyItem(item)"
            >
              mdi-clipboard-text-clock
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Istorija') }}</div>
        </v-tooltip>
      </div>
      <!-- canViewInModal -->
      <div v-if="item.canViewInModal">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="viewInModaltem(item)"
            >
              mdi-eye-check
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Peržiūrėti') }}</div>
        </v-tooltip>
      </div>

        <!-- canViewEmail -->
      <div v-if="item.canViewEmail">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="viewInModaltem(item)"
            >
              mdi-comment-eye
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Peržiūrėti') }}</div>
        </v-tooltip>
      </div>

        <!-- canViewSMS -->
      <div v-if="item.canViewSMS">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="viewInModaltem(item)"
            >
              mdi-comment-eye-outline
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Peržiūrėti') }}</div>
        </v-tooltip>
      </div>
      
      <!-- canAddChild -->
      <div v-if="item.canAddChild">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="newItem(item)"
            >
              mdi-plus-box-outline
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Pridėti naują paslaugą') }}</div>
        </v-tooltip>
      </div>
      <!-- canSelect -->
      <div v-if="item.canSelect">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              color="primary"
              v-bind="attrs"
              v-on="on"
              @click="selectItem(item)"
            >
              mdi-account-check-outline
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Pasirinkti') }}</div>
        </v-tooltip>
      </div>
      <!-- canDuplicate -->
      <div v-if="item.canDuplicate">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="table-action mx-1"
              dense
              v-bind="attrs"
              v-on="on"
              @click="duplicateItem(item)"
            >
              mdi-content-duplicate
            </v-icon>
          </template>
          <div style="width: 8rem; text-align: center;" class="tooltip-text">
            {{ $t('Kurti dokumentą šio dokumento pagrindu') }}
          </div>
        </v-tooltip>
      </div>
      <!-- canDelete -->
      <div v-if="item.canDelete">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="table-action mx-1"
              dense
              v-bind="attrs"
              v-on="on"
              @click="deleteItem(item)"
            >
              mdi-delete-outline
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Šalinti') }}</div>
        </v-tooltip>
      </div>
      <!-- canSign -->
      <div v-if="item.canSign">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="table-action mx-1"
              dense
              v-bind="attrs"
              v-on="on"
              @click="signItem(item)"
            >
              mdi-file-sign
            </v-icon>
          </template>
          <!-- <div class="tooltip-text">{{ $t('Pasirašyti') }}</div> -->
          <div class="tooltip-text">{{ $t('Peržiūrėti ir pasirašyti') }}</div>
        </v-tooltip>
      </div>
      <!-- signaturesEditable -->
      <div v-if="item.signaturesEditable">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="table-action mx-1"
              dense
              v-bind="attrs"
              v-on="on"
              @click="signaturesEditable(item)"
            >
              mdi-account-edit
            </v-icon>
          </template>
          <!-- <div class="tooltip-text">{{ $t('Pasirašyti') }}</div> -->
          <div class="tooltip-text">{{ $t('Peržiūrėti ir redaguoti') }}</div>
        </v-tooltip>
      </div>
      <!-- canSubdelegate -->
      <div v-if="item.canSubdelegate">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              :class="'table-action mx-1 ' + (item.subdelegateDisabled ? 'disabledIcon' : '')"
              dense
              v-bind="attrs"
              v-on="on"
              @click="subdelegateItem(item)"
            >
              mdi-account-reactivate-outline
            </v-icon>
          </template>
          <div class="tooltip-text">{{ item.subdelegateDisabled ? $t('Pradėtas įgaliojimo panaikinimo / atsisakymo procesas!') : $t('Perįgalioti') }}</div>
        </v-tooltip>
      </div>
      <!-- fakeStatus -->
      <div v-if="isLocal && fakeStatus && (item.status == 804 || item.status == 'waiting-for-payment')">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="table-action mx-1"
              dense
              v-bind="attrs"
              v-on="on"
              @click="fakeStatusItem(item)"
            >
              mdi-exit-to-app
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('fakeStatus') }}</div>
        </v-tooltip>
      </div>
      <!-- canRestore -->
      <div v-if="item.canRestore">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="table-action mx-1"
              dense
              v-bind="attrs"
              v-on="on"
              @click="restoreItem(item)"
            >
              mdi-restore
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Atstatyti') }}</div>
        </v-tooltip>
      </div>
      <!-- canRetry -->
      <div v-if="item.canRetry">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="table-action mx-1"
              dense
              v-bind="attrs"
              v-on="on"
              @click="retryItem(item)"
            >
              mdi-restore
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Pabandyti dar kartą') }}</div>
        </v-tooltip>
      </div>
      <!-- canTerminate -->
      <div v-if="item.canTerminate">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="table-action mx-1"
              dense
              v-bind="attrs"
              v-on="on"
              @click="terminateItem(item)"
            >
              mdi-file-cancel-outline
            </v-icon>
          </template>
          <div class="tooltip-text">{{ item.type == "PP" ? $t('Atšaukti prokūrą') : $t('Panaikinti') }}</div>
        </v-tooltip>
      </div>
      <!-- canRefuse -->
      <div v-if="item.canRefuse">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="table-action mx-1"
              dense
              v-bind="attrs"
              v-on="on"
              @click="refuseItem(item)"
            >
              mdi-file-cancel-outline
            </v-icon>
          </template>
          <div class="tooltip-text">{{ item.type == "PP" ? $t('Atsisakyti prokūros') : $t('Atsisakyti') }}</div>
        </v-tooltip>
      </div>
       <!-- canInputDVS -->
      <div v-if="item.canInputDVS">
        <v-tooltip style="z-index: 99;" top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="inputDVSItem(item)"
            >
              mdi-pencil-outline
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Įvesti DVS duomenis') }}</div>
        </v-tooltip>
      </div>
      <!-- canDownload -->
      <div v-if="item.canDownload">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="downloadItem(item)"
            >
              mdi-file-move-outline
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Atsisiųsti') }}</div>
        </v-tooltip>
      </div>
      <!-- Tooltip  -->
      <div v-if="item.showDownloadTooltip">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                dense
                class="table-action mx-1 table-action-red"
                v-bind="attrs"
                v-on="on"
              >
                mdi-exclamation
              </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Projektas saugomas 30d.!') }}</div>
        </v-tooltip>
      </div>
      <!-- canDestroyData -->
      <div v-if="item.canDestroyData">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="destroyDataItem(item)"
            >
              mdi-close
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Sunaikinti duomenis') }}</div>
        </v-tooltip>
      </div>
      <!-- addJurRepresenter -->
      <div v-if="item.addJurRepresenter">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="addJurRepresenterItem(item)"
            >
              mdi-account-plus
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Pridėti atstovą') }}</div>
        </v-tooltip>
      </div>
        <!-- addCustomItem -->
      <div v-if="item.canAddCustom">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="addCustomItem(item)"
            >
              mdi-plus
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Pridėti') }}</div>
        </v-tooltip>
      </div>
      <!-- canEditContacts -->
      <div v-if="item.canEditContacts">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              @click="emitEvent(item, 'editContacts')"
            >
              mdi-card-account-mail-outline
            </v-icon>
          </template>
          <div class="tooltip-text">{{ $t('Redaguoti asmens kontaktinius duomenis') }}</div>
        </v-tooltip>
      </div>
    </div>
    <!-- showSign -->
    <div v-if="item.showSign">
      <v-chip
        color="red"
        small
        outlined
        class="mt-1 mb-1"
        @click="editItem(item)"
      >
        Laukia pasirašymo
      </v-chip>
    </div>
    <!-- showConfirm -->
    <div v-if="item.showConfirm">
      <v-chip small outlined class="mt-1 mb-1" @click="editItem(item)">
        {{ item.showConfirmText }}
      </v-chip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ElTableAction',
  props: {
    item: Object,
    fakeStatus: Boolean,
  },
  computed: {
    isLocal() {
      return (
        process.env.VUE_APP_LOCAL === 'local'
      )
    },
  },
  methods: {
    historyItem(item) {
      this.$emit('historyItem', item)
    },
    inputDVSItem(item) {
      this.$emit('inputDVSItem', item)
    },
    destroyDataItem(item) {
      this.$emit('destroyDataItem', item)
    },
    SetReadItem(item) {
      this.$emit('SetReadItem', item)
    },
    signItem(item) {
      this.$emit('signItem', item)
    },
    signaturesEditable(item) {
      this.$emit('signaturesEditable', item)
    },
    searchItem(item) {
      this.$emit('searchItem', item)
    },
    reloadItem(item) {
      this.$emit('reloadItem', item)
    },
    downloadItem(item) {
      this.$emit('downloadItem', item)
    },
    addToCartItem(item) {
      this.$emit('addToCartItem', item)
    },
    goToCartItem(item) {
      this.$emit('goToCartItem', item)
    },
    editItem(item) {
      this.$emit('editItem', item)
    },
    fixPerson(item) {
      this.$emit('fixPerson', item)
    },
    iregEditItem(item) {
      this.$emit('editItem', item)
    },
    iregViewItem(item) {
      this.$emit('viewItem', item)
    },
    approveSignatures(item) {
      this.$emit('approveSignatures', item)
    },
    viewSignatures(item) {
      this.$emit('viewSignatures', item)
    },
    viewItem(item) {
      this.$emit('viewItem', item)
    },
    viewInModaltem(item) {
      this.$emit('viewInModaltem', item)
    },
    refuseItem(item) {
      this.$emit('refuseItem', item)
    },
    terminateItem(item) {
      this.$emit('terminateItem', item)
    },
    fakeStatusItem(item) {
      this.$emit('fakeStatusItem', item)
    },
    selectItem(item) {
      this.$emit('selectItem', item)
    },
    duplicateItem(item) {
      this.$emit('duplicateItem', item)
    },
    deleteItem(item) {
      this.$emit('deleteItem', item)
    },
    subdelegateItem(item) {
      if (!this.item.subdelegateDisabled) {
        this.$emit('subdelegateItem', item)
      }
    },
    restoreItem(item) {
      this.$emit('restoreItem', item)
    },
    retryItem(item) {
      this.$emit('retryItem', item)
    },
    newItem(item) {
      this.$emit('newItem', item)
    },
    addJurRepresenterItem(item) {
      this.$emit('addJurRepresenterItem', item)
    },
    addCustomItem(item) {
      this.$emit('addCustomItem', item)
    },
    emitEvent(item, event) {
      this.$emit(event, item)
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/color.scss';
.table-action {
  line-height: 24px;
}
.table-action-red {
  color: red;
}
.table-action:hover {
  color: $primary;
}
.actions div {
  display: inline-flex;
  line-height: 24px;
}

.disabledIcon {
  opacity: 0.4 !important;
}
</style>
